import { X } from 'lucide-react'
import layoutOf from 'utils/layoutStyle'
import { Container, Input, ClearButton } from './styles'

/*
  Campo de texto com a caixa do @cutilei/ui (36 px) e, com `isClearable`, o X que limpa dentro dela.
  Do `containerStyle` e do `inputStyle` valem só as chaves de layout (largura, margens, flex): o
  visual é o da lib, e a sombra e o padding que as buscas passavam já vêm dela.
*/
export default function TextInput({
  placeholder,
  value,
  isClearable = false,
  onChange: handleChange,
  onBlur: handleBlur = () => null,
  onClear: handleClear,
  containerStyle = {},
  inputStyle = {},
  ...props
}) {
  const showClear = isClearable && value !== ''

  return (
    <Container style={layoutOf(containerStyle)}>
      <Input
        type='text'
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        style={layoutOf(inputStyle)}
        $withAction={showClear}
        {...props}
      />
      {showClear && (
        <ClearButton aria-label='Limpar' onClick={handleClear}>
          <X size={16} aria-hidden/>
        </ClearButton>
      )}
    </Container>
  )
}
